import { render, staticRenderFns } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=a50a8118&"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports